import { render, staticRenderFns } from "./SwiperExample.vue?vue&type=template&id=349cd2af&scoped=true"
import script from "./SwiperExample.vue?vue&type=script&lang=ts"
export * from "./SwiperExample.vue?vue&type=script&lang=ts"
import style0 from "./SwiperExample.vue?vue&type=style&index=0&id=349cd2af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349cd2af",
  null
  
)

export default component.exports